var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 62,
    viewBox: "0 0 67 62",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9042 42.2367L58.5637 36.6177C60.8177 35.4764 63.4612 35.934 64.5508 37.8468C65.6375 39.7605 64.6841 42.2593 62.4301 43.4006L38.2383 55.6279L36.9588 55.93L14.3956 56.5043C14.3956 56.5043 11.4904 57.2721 8 61",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 51L11.2295 41.9459C16.2287 38.7036 22.1559 40.4921 22.1559 40.4921C25.026 41.2195 30.3569 41.3827 30.3569 41.3827H39.2069C41.8431 41.3827 44 43.1933 44 45.4068C44 47.6203 41.8431 49.4309 39.2069 49.4309H26.9643",
    stroke: "#394553",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0217 27.3657C32.0217 29.9278 34.2564 32 37.0086 32C39.767 32 42 29.9278 42 27.3657C42 24.8072 39.3372 23.685 36.9995 22.4986C34.6619 21.315 32 20.1946 32 17.6361C32 15.074 34.2312 13 36.9887 13C39.7454 13 41.9783 15.074 41.9783 17.6361",
    stroke: "#D08E01",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 13V9",
    stroke: "#D08E01",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 36V32",
    stroke: "#D08E01",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5973 35C16.3312 31.6041 15 27.4586 15 22.9852C15 17.1066 17.3011 11.7933 21 8",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3.89716C29.7703 2.6786 32.8498 2 36.0942 2C48.1919 2 58 11.4356 58 23.0722C58 27.0735 56.8424 30.814 54.8305 34",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.86adc79a2d91a9655db197bd37b7c484.svg";
export { ForwardRef as ReactComponent };